import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import visuallyHidden from '@mui/utils/visuallyHidden';
import * as React from 'react';

import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import {
  changeCurrency,
  loadStoredCurrency,
} from '../../redux/reducers/currencyReducer';
import { supportedCurrencies } from '../../utils/currencyTools';

const CurrencySelector: React.FC = () => {
  const dispatch = useAppDispatch();
  const currency = useAppSelector((state) => state.currency.currencyCode);
  // HeaderNav renders a selector in both its mobile and desktop layouts
  // (CSS shows one), so ids must be unique per instance.
  const id = React.useId();

  React.useEffect(() => {
    dispatch(loadStoredCurrency());
  }, [dispatch]);

  const handleChange = (event: SelectChangeEvent) => {
    dispatch(changeCurrency(event.target.value as string));
  };

  return (
    <FormControl sx={{ m: 1, minWidth: 110 }} size="small">
      <span id={`${id}-label`} style={visuallyHidden}>
        Currency
      </span>
      <Select
        id={id}
        labelId={`${id}-label`}
        value={currency}
        onChange={handleChange}
      >
        {supportedCurrencies.map((option) => (
          <MenuItem key={option.code} value={option.code}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CurrencySelector;
